import { render } from "./CaracProdutoRA.vue?vue&type=template&id=5be3e1ad&scoped=true"
import script from "./CaracProdutoRA.vue?vue&type=script&lang=js"
export * from "./CaracProdutoRA.vue?vue&type=script&lang=js"

import "./CaracProdutoRA.vue?vue&type=style&index=0&id=5be3e1ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be3e1ad"]])

export default __exports__